module.exports = __webpack_public_path__ + "static/media/icon-logout.f173a6c9.svg";